<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            ADD - ANIMAL VACCINE DETAIL
          </h2>
          <!--<p>Create animal vaccine detail</p>-->
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
      </div>
      <br>
      <form class="row" [formGroup]="Formvalidation">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Vaccine Name<span class="mandatory_star" style="color: rgb(237, 95, 95); padding-left: 5px;">*</span></label>
            <input type="text" name="vaccinename" id="vaccinename" value="" class="form-control"
              [(ngModel)]="vaccine_name" [ngModelOptions]="{standalone: true}">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Batch No<span class="mandatory_star" style="color: rgb(237, 95, 95); padding-left: 5px;">*</span></label>
            <input type="text" name="batchNumber" id="batchNumber" value="" class="form-control" [(ngModel)]="batch_no"
              [ngModelOptions]="{standalone: true}">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>

          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Expiry Date</label>
            <input type="date" id="ExpiryDate" name="expirydate" value="Cow" class="form-control">
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label for="fromage">Dose Value<span class="mandatory_star" style="color: rgb(237, 95, 95); padding-left: 5px;">*</span></label>
                <input type="number" id="dosevalue" name="dosevalue" class="form-control" min="0" max="50" step="1"
                  [ngModelOptions]="{standalone: true}" [(ngModel)]="dose_value">
                <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>

              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label for="toage">Units</label>
                <input type="text" id="unit" name="unit" value="mg" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Vaccine Date 1<span class="mandatory_star" style="color: rgb(237, 95, 95); padding-left: 5px;">*</span></label>
            <input type="date" name="VaccineDate1" id="VaccineDate1" value="" class="form-control"
              [(ngModel)]="vaccine_date1" [ngModelOptions]="{standalone: true}">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>

          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="VaccineDate2">
              Remark
            </label>

            <input
              type="text"
              name="VaccineDate2"
              id="VaccineDate2"
              class="form-control"
              [(ngModel)]="vaccine_date2"
              [ngModelOptions]="{standalone: true}"
              placeholder="Enter Here"
            >
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <button type="submit" class="btn btn-fill btn-primary mb-3" (click)="AnimalVaccine()">Submit<div
              class="ripple-container"></div></button>
          <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>